module.exports = {
  login(user, pass, cb) {
    cb = arguments[arguments.length - 1]
    if (cb == undefined) {
      // validate from app re-entry
      cb = (res) => {
        if (res.authenticated) {
          this.onChange(true)
        } else {
          delete localStorage.token
          window.location = "/login"
        }
      }
    }
    if (localStorage.token) {
      // auth and retrieve user info
      userinfoRequest(cb)
      return
    } else if (!user || !pass) {
      delete localStorage.token
      window.location = "/login"
    }

    authRequest(user, pass, (res) => {
      if (res.authenticated) {
        if (cb) cb(true)
        this.onChange(true)
      } else {
        if (cb) cb(false)
        this.onChange(false)
      }
    })
  },

  // getToken() {
  //   return localStorage.token
  // },

  logout() {
    delete localStorage.token
    delete localStorage.tokenCreation
    window.location = "/login"
  },

  loggedIn() {
    if (localStorage.tokenCreation) {
      var now = new Date().getTime()
      var milisec_diff = now - new Date( localStorage.tokenCreation ).getTime()
      var hour_diff = Math.floor(milisec_diff / 1000 / 60 / (60 * 1))
      console.log("Token life: ", hour_diff, "hrs")
      if (hour_diff >= 0 && hour_diff < 20) {

      } else {
        return false
      }
    }
    return !!localStorage.token && !!localStorage.username && !!localStorage.user_id && !!localStorage.tokenCreation
  },

  onChange() {}
}

function authRequest(user, pass, cb) {
  fetch(API_ENDPOINT+'/authenticate', {
    method: 'GET',
    headers: {
      'Authorization': 'Basic ' + btoa(user+':'+pass),
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  }).then(function(response) {
    let token = "" + response.headers.get("Authorization")

    if (token.indexOf("Bearer ") !== 0 ) {
      return cb({ authenticated: false })
    }

    localStorage.token = token
    localStorage.tokenCreation = new Date()
    userinfoRequest(cb)
  })
  .catch(function(error) { cb({ authenticated: false }) })
}

function userinfoRequest(cb) {
  fetch(API_ENDPOINT+'/user', {
    method: 'GET',
    headers: {
      'Authorization': localStorage.token,
    }
  }).then(function(response) {
      response.json().then(function(json) {

        // who am i?
        localStorage.username = json.username
        localStorage.user_id = json.user_id

        if (cb) {
          cb({
            authenticated: true,
            token: localStorage.token
          })
        }
      }).catch(function(error) { throw error })
  })
  .catch(function(error) {
    console.log(error)
    if (cb) { cb({ authenticated: false }); return }
    delete localStorage.token
    window.location = "/login"
  })
}



// WEBPACK FOOTER //
// ./src/auth.jsx